import React from 'react';
import { useTranslation } from 'react-i18next';
import qs from 'query-string';
import SyncedInfoLink from './SyncedInfoLink';

const getPowerPointDisplayName = (sourceName, groupName) => {
  if (sourceName) {
    const slideName = sourceName.replace(groupName, '').trimEnd();
    if (slideName) {
      return `${slideName}`;
    }
  }
  return groupName;
};

// eslint-disable-next-line no-unused-vars
const getExcelDisplayName = (sourceName, type) => {
  const lastIndex = sourceName.lastIndexOf('!');
  if (type === 'ExcelNamedRange' && lastIndex !== -1)
    return sourceName.slice(0, lastIndex);
  if (type === 'ExcelCellRange')
    return sourceName.slice(0, lastIndex).slice(1, -1);
  return sourceName;
};

const getDisplaySourceName = (sourceName, groupName, type) => {
  if (groupName) {
    return getPowerPointDisplayName(sourceName, groupName);
  }
  return getExcelDisplayName(sourceName, type);
};

const getSourceNameFromAutoSync = (autoSync) => {
  const { type, data } = autoSync;
  const { cellRange, worksheetName } = data || {};
  switch (type) {
    case 'ExcelCellRange':
      return cellRange;
    case 'ExcelNamedRange':
    case 'ExcelChart':
      return worksheetName;
    default:
      return worksheetName;
  }
};

const getSourceNameFromWorksheetName = (worksheetName, slideNumber) => {
  let name = '';
  if (slideNumber) {
    name = `Slide ${slideNumber}`;
  } else {
    name = worksheetName;
  }
  return name;
};

const ExcelPPTSyncInfo = ({ excelPPTItem }) => {
  const {
    groupName,
    worksheetName,
    fileName,
    autoSync,
    sharePointItemUrl,
    slideNumber,
  } = excelPPTItem;
  const sourceName = autoSync
    ? getSourceNameFromAutoSync(autoSync)
    : getSourceNameFromWorksheetName(worksheetName, slideNumber);
  const { t } = useTranslation();
  const displayName = getDisplaySourceName(
    sourceName,
    groupName,
    autoSync?.type
  );

  let defaultItemUrlName = (sharePointItemUrl || '').split('/').pop();
  if (defaultItemUrlName?.includes('file')) {
    const defaultItemUrlNamesplitForFile = defaultItemUrlName
      ?.split('file=')
      ?.pop();
    const defaultItemUrlNamesplit =
      defaultItemUrlNamesplitForFile?.split('&')?.[0];
    defaultItemUrlName = defaultItemUrlNamesplit;
    if (defaultItemUrlNamesplit?.includes('%20')) {
      defaultItemUrlName = defaultItemUrlNamesplit?.replace(/%20/g, ' ');
    }
  }
  // either we have sharePointItemUrl or fileName with the URL
  // or fileName contains the correct name
  const isFileNameFullPath = (fileName || '').includes('://');
  let sharePointItemName = isFileNameFullPath
    ? qs.parse(fileName).file
    : fileName || defaultItemUrlName;

  // workaround for PPT file, because the object contain two di
  if (!sharePointItemName && isFileNameFullPath) {
    sharePointItemName = fileName.split('\\').pop().split('/').pop();
  }

  return (
    <>
      {`'${displayName}' ${t('in')} `}
      <SyncedInfoLink
        name={
          isFileNameFullPath
            ? sharePointItemName
            : fileName || defaultItemUrlName
        }
        url={sharePointItemUrl || fileName}
      />
    </>
  );
};

export default ExcelPPTSyncInfo;
